import ApiService from "@/base/api/api.service"

import {
    GET_SUGGESTED_USERS
} from "@/store/actions.type"

import {
    PUSH_SUGGESTED_USERS,
    SET_ERROR
} from "@/store/mutations.type"

import {
    GET_SUGGESTED_USERS_URL
} from "@/base/api/config";

//const StateKey = 'suggestedUsers'

export default {
    async [GET_SUGGESTED_USERS]({ commit }) {

        try {
            const res = await ApiService.get(GET_SUGGESTED_USERS_URL)
            commit(PUSH_SUGGESTED_USERS, res.data.user)
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    }
}